var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import axios from "axios";
import { throttle, bind } from "lodash-decorators";
import Autocomplete from "./autocomplete.vue";
var SupportSearch = /** @class */ (function (_super) {
    __extends(SupportSearch, _super);
    function SupportSearch() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = "support-search";
        _this.autocompleteResults = [];
        _this.loading = false;
        return _this;
    }
    SupportSearch.prototype.onInput = function (_a) {
        var _this = this;
        var value = _a.target.value;
        if (value.length > 2) {
            axios
                .get("/support/quick-search/", { params: { search: value } })
                .then(function (res) { return (_this.autocompleteResults = res.data); });
        }
    };
    SupportSearch.prototype.onChange = function (result) {
        if (result && result.value) {
            location.replace(result.value);
        }
    };
    __decorate([
        Prop({ type: String, default: "" })
    ], SupportSearch.prototype, "defaultValue", void 0);
    __decorate([
        throttle(500),
        bind()
    ], SupportSearch.prototype, "onInput", null);
    SupportSearch = __decorate([
        Component({
            components: { Autocomplete: Autocomplete }
        })
    ], SupportSearch);
    return SupportSearch;
}(Vue));
export default SupportSearch;
